<template>
  <div class="navbarPanel">
    <div class="navbarPanel__menu">
      <a @click="showMenu = !showMenu">
        <img
          loading="lazy"
          src="../../assets/icon_hamburguer2.png"
          alt="Abrir e fechar menu"
        />
      </a>
    </div>
    <nav class="navbarPanel__nav" v-if="showMenu">
      <ul>
        <router-link to="/panel/dashboard">
          <li>
            <i class="fa fa-th-large" aria-hidden="true"></i>
            Dashboard
          </li>
        </router-link>
        <li @click="showVendas = !showVendas">
          <i class="fa fa-shopping-cart" aria-hidden="true"></i>
          <span>Vendas</span>
          <ul v-if="showVendas">
            <router-link to="/panel/orders">
              <li>Minhas Vendas</li>
            </router-link>
            <router-link to="/">
              <li>Criar Pedido</li>
            </router-link>
            <router-link to="/"> <li>Criar Orçamento</li></router-link>
            <router-link to="/panel/orders/blockedDocuments">
              <li>Pedidos Bloqueados</li>
            </router-link>
          </ul>
        </li>
        <li @click="showRelatorios = !showRelatorios">
          <i class="fa fa-bar-chart" aria-hidden="true"></i>
          <span>Relatórios</span>
          <ul v-if="showRelatorios">
            <!-- <router-link to="">
              <li>Análise de Custos</li>
            </router-link>
            <router-link to=""> <li>Extrato de Comissão</li></router-link> -->
            <router-link to="/panel/orders">
              <li>Pedidos - OMS</li>
            </router-link>
            <!-- <router-link to="">
              <li>Relatórios Personalizados</li>
            </router-link> -->
          </ul>
        </li>
        <li @click="showCadastros = !showCadastros">
          <i class="fa fa-user" aria-hidden="true"></i>
          <span>Cadastros</span>
          <ul v-if="showCadastros">
						<a href="/panel/register?tp=fisica">
							<li>Pessoa Fìsica</li>
						</a>
						<a href="/panel/register?tp=juridica">
							<li>Pessoa Jurídica</li>
						</a>
            <!-- <router-link to="/panel/register?tp=fisica">
              <li>Pessoa Fìsica</li>
            </router-link>
						<router-link to="/panel/register?tp=juridica">
              <li>Pessoa Jurídica</li>
            </router-link> -->
            <router-link to="/panel/ManagementPartner"> <li>Gerenciar Parceiro</li></router-link>
            <!-- <router-link to="/panel/historic">
              <li>Histórico do Cliente</li>
            </router-link> -->
          </ul>
        </li>
        <!-- <li @click="showRT = !showRT">
          <i class="fa fa-usd" aria-hidden="true"></i>
          <span>Fechamento de RT</span>
          <ul v-if="showRT">
            <router-link to="">
              <li>Apuração</li>
            </router-link>
            <router-link to="">
              <li>Suporte</li>
            </router-link>
          </ul>
        </li> -->
        <!-- <li @click="showCatalogo = !showCatalogo">
          <i class="fa fa-sitemap" aria-hidden="true"></i>
          <span>Catálogo de Produtos</span>
          <ul v-if="showCatalogo">
            <router-link to="/panel/products">
              <li>Produtos e SKUs</li>
            </router-link>
            <router-link to="">
              <li>Sincronizar Itens</li>
            </router-link>
          </ul>
        </li> -->
        <!-- <li @click="showFinanceiro = !showFinanceiro">
          <i class="fa fa-money" aria-hidden="true"></i>
          <span>Financeiro</span>
          <ul v-if="showFinanceiro">
            <router-link to="">
              <li>RT - Cálculo Parceiro</li>
            </router-link>
            <router-link to="">
              <li>RT - Validação Nota Fiscal</li>
            </router-link>
            <router-link to="">
              <li>Finalizar Compra Depósito</li>
            </router-link>
            <router-link to="">
              <li>Finalizar Compra de Triangulação/NF Antecipada</li>
            </router-link>
            <router-link to="">
              <li>Finalizar Compra à Prazo</li>
            </router-link>
            <router-link to="">
              <li>Finalizar Compra BNDES</li>
            </router-link>
            <router-link to="">
              <li>Leitura Arquivo Adquirente</li>
            </router-link>
            <router-link to="">
              <li>PCI</li>
            </router-link>
          </ul>
        </li> -->
        <li v-if='!acessoParceiro' @click="showMarketing = !showMarketing">
          <i class="fas fa-bullhorn"></i>
          <span>Marketing</span>
          <ul v-if="showMarketing">
            <router-link to="/panel/campaigns">
              <li>Campanhas</li>
            </router-link>
            <router-link to="/panel/profitz/redemptions">
              <li>Resgates</li>
            </router-link>
          </ul>
        </li>
				<li>
          <i class="fas fa-download"></i>
					<router-link to="/panel/centralDownload">
              <span>Central de Downloads</span>
            </router-link>
        </li>
        <li @click="showLinks = !showLinks">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span>Links Úteis</span>
          <ul v-if="showLinks">
            <!-- <router-link to="/panel/catalogs">
              <li>Catálogos, manuais etc</li>
            </router-link> -->
            <router-link to="/panel/booking">
              <li>Booking</li>
            </router-link>
          </ul>
        </li>
        <li @click="showConfigs = !showConfigs" v-if="auth.validaAcesso(['TI', 'GERENTE', 'MENU COMPLETO', 'EDITOR (SOLAR)'])">
          <i class="fa fa-cog" aria-hidden="true"></i>
          <span>Configurações</span>
          <ul v-if="showConfigs">
            <router-link to="/panel/banners" v-if="auth.validaAcesso(['TI', 'GERENTE', 'MENU COMPLETO'])">
              <li>Banners</li>
            </router-link>
            <router-link to="/panel/loginConfigs" v-if="auth.validaAcesso(['TI', 'GERENTE', 'MENU COMPLETO'])">
              <li>Tela de Login</li>
            </router-link>
            <router-link to="/panel/KitsMaintenance" v-if="auth.validaAcesso(['TI', 'EDITOR (SOLAR)'])">
              <li>Manutenção de Kit's</li>
            </router-link>
          </ul>
        </li>
        <li>
          <a href="#" @click="deleteAllCookies">
            <i class="fa fa-times" aria-hidden="true"></i>
            Sair</a
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import auth from "../../util/authPages";
export default {
  data() {
    return {
      showVendas: false,
      showCadastros: false,
      showRT: false,
      showCatalogo: false,
      showFinanceiro: false,
      showConfiguracoes: false,
      showLinks: false,
      showConfigs: false,
      showMarketing: false,
      showMenu: false,
      showRelatorios: false,
      parceiros: [],
      vendedorResponsavel: null,
      auth: null,
      acessoParceiro: true
    };
  },
  methods: {
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        if (dados.Parceiros != undefined) {
          this.parceiros = dados.Parceiros;
        }

        this.vendedorResponsavel = dados.vendedorResponsavel;

        this.token = dados.token;
      } catch (e) {
        console.log(e);
      }
    },
    deleteAllCookies() {
      localStorage.clear();

      let url = window.location.href;
      window.location.href = url;
    },
  },

  created() {
    // Inicializa a variavel de valida as páginas
    this.auth = auth;
    let tipoAcesso = JSON.parse(localStorage.getItem("login")).perfil;
    let validacao = tipoAcesso.find(x => x.NomePerfil == 'TI');
    if(validacao){
      this.acessoParceiro = false;
    }
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.navbarPanel {
  &__menu {
    position: absolute;
    top: 25px;
    left: 20px;

    a {
      cursor: pointer;
    }
  }

  &__nav {
    background: var(--standardGreen);
    color: var(--customWhite);
    position: absolute;
    min-height: 100vh;
    left: 0;
    z-index: 9999;
    top: 133px;
    width: 60%;

    @media (min-width: 480px) and (max-width: 768px) {
      width: 40%;
      top: 70px;
    }

    @media (min-width: 769px) {
      width: 20%;
      top: 70px;
    }

    span {
      padding-left: 5px;
      font-weight: bold;

      &:after {
        content: "\02C5";
        position: absolute;
        right: 20px;
      }
    }
  }

  a {
    color: var(--customWhite);
    text-decoration: none;
    font-weight: bold;
  }

  ul li {
    padding: 10px 0 10px 20px;
    list-style: none;
    cursor: pointer;
    font-size: 1rem;

    &:hover {
      background: #0998a871;
    }

    ul {
      margin: 15px 0;
      border-left: 1px solid #dedede26;
      a {
        font: 500 0.95rem/1.4 "Soleto", sans-serif;

        li {
          list-style: none;
          padding: 10px 30px;
          font-size: 0.95rem;
        }
      }
    }
  }
}
</style>
